var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "returnInfo" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "listContent" },
        [
          _c(
            "Timeline",
            _vm._l(_vm.visitList, function(item) {
              return _c(
                "TimelineItem",
                {
                  key: item.id,
                  attrs: { color: item.type == "回访记录" ? "blue" : "green" }
                },
                [
                  _c("p", { staticClass: "time" }, [
                    _vm._v(_vm._s(item.create_time))
                  ]),
                  _vm._v(" "),
                  item.type == "回访记录"
                    ? _c("p", { staticClass: "content" }, [
                        _vm._v(
                          "\n            回访记录：" +
                            _vm._s(item.group) +
                            "\n            " +
                            _vm._s(item.come_way) +
                            "\n            " +
                            _vm._s(item.return_name) +
                            "\n            "
                        ),
                        _c("span", { staticStyle: { color: "blue" } }, [
                          _vm._v(_vm._s(item.content))
                        ]),
                        _vm._v(
                          "\n            下次回访时间：" +
                            _vm._s(item.visit_time) +
                            " " +
                            _vm._s(item.store) +
                            "\n            " +
                            _vm._s(item.department) +
                            " " +
                            _vm._s(item.user) +
                            "\n          "
                        )
                      ])
                    : _c("p", { staticClass: "content" }, [
                        _vm._v(
                          "\n            系统记录：" +
                            _vm._s(item.operate_log) +
                            "\n            "
                        ),
                        _c("span", { staticStyle: { color: "blue" } }, [
                          _vm._v(_vm._s(item.content))
                        ]),
                        _vm._v(
                          "\n            " +
                            _vm._s(item.store) +
                            " " +
                            _vm._s(item.department) +
                            " " +
                            _vm._s(item.user) +
                            "\n          "
                        )
                      ])
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("Divider", [_vm._v("没有更多了")])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "addReturnInfo" }, [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c("h3", [_vm._v("添加回访")]),
          _vm._v(" "),
          _c(
            "Button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.handleSubmit("formValidate")
                }
              }
            },
            [_vm._v("确认")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "listContent" },
        [
          _c(
            "Form",
            {
              ref: "formValidate",
              attrs: {
                model: _vm.formItem,
                rules: _vm.ruleValidate,
                "label-width": 80
              }
            },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "客户分组", prop: "group_id" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.formItem.group_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem, "group_id", $$v)
                                },
                                expression: "formItem.group_id"
                              }
                            },
                            _vm._l(_vm.customerGroudList, function(item) {
                              return _c(
                                "Option",
                                {
                                  key: item.id,
                                  attrs: { value: item.id + "" }
                                },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "预产期", prop: "child_birth" } },
                        [
                          _c("DatePicker", {
                            staticStyle: { display: "block" },
                            attrs: {
                              type: "date",
                              placeholder: "请选择",
                              editable: false,
                              clearable: false
                            },
                            on: { "on-change": _vm.ChildBirthChange },
                            model: {
                              value: _vm.formItem.child_birth,
                              callback: function($$v) {
                                _vm.$set(_vm.formItem, "child_birth", $$v)
                              },
                              expression: "formItem.child_birth"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "跟进结果", prop: "come_status" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.formItem.come_status,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem, "come_status", $$v)
                                },
                                expression: "formItem.come_status"
                              }
                            },
                            [
                              _c("Option", { attrs: { value: "1" } }, [
                                _vm._v("待确定")
                              ]),
                              _vm._v(" "),
                              _c("Option", { attrs: { value: "3" } }, [
                                _vm._v("有需求")
                              ]),
                              _vm._v(" "),
                              _c("Option", { attrs: { value: "2" } }, [
                                _vm._v("已到店")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formItem.come_status == "2"
                    ? _c(
                        "Col",
                        { attrs: { span: "8" } },
                        [
                          _c(
                            "FormItem",
                            {
                              staticClass: "mb-10",
                              attrs: { label: "到店时间", prop: "come_date" }
                            },
                            [
                              _c("DatePicker", {
                                staticStyle: { display: "block" },
                                attrs: {
                                  format: "yyyy-MM-dd",
                                  placeholder: "请选择"
                                },
                                model: {
                                  value: _vm.formItem.come_date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formItem, "come_date", $$v)
                                  },
                                  expression: "formItem.come_date"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formItem.come_status == "2"
                    ? _c(
                        "Col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "到店方式", prop: "come_id" } },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.formItem.come_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formItem, "come_id", $$v)
                                    },
                                    expression: "formItem.come_id"
                                  }
                                },
                                _vm._l(_vm.returnSettingList, function(item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.id,
                                      attrs: { value: item.id + "" }
                                    },
                                    [_vm._v(_vm._s(item.return_info))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.formItem.come_status == "2"
                ? _c(
                    "Row",
                    [
                      _c(
                        "Col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "到店结果",
                                prop: "arrival_result_id"
                              }
                            },
                            [
                              _c(
                                "RadioGroup",
                                {
                                  model: {
                                    value: _vm.formItem.arrival_result_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formItem,
                                        "arrival_result_id",
                                        $$v
                                      )
                                    },
                                    expression: "formItem.arrival_result_id"
                                  }
                                },
                                _vm._l(_vm.arrival_result, function(item) {
                                  return _c(
                                    "Radio",
                                    {
                                      key: item["id"].toString(),
                                      attrs: { label: item["id"].toString() }
                                    },
                                    [_vm._v(_vm._s(item["result"]))]
                                  )
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _vm.formItem.come_status == "2" &&
                              _vm.formItem.arrival_result_id == "0"
                                ? _c("Input", {
                                    attrs: {
                                      maxlength: 20,
                                      placeholder: "1-12个字符"
                                    },
                                    model: {
                                      value: _vm.formItem.other,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formItem, "other", $$v)
                                      },
                                      expression: "formItem.other"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "回访方式", prop: "return_id" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.formItem.return_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem, "return_id", $$v)
                                },
                                expression: "formItem.return_id"
                              }
                            },
                            _vm._l(_vm.returnMode, function(item) {
                              return _c(
                                "Option",
                                {
                                  key: item.id,
                                  attrs: { value: item.id + "" }
                                },
                                [_vm._v(_vm._s(item.return_info))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "下次回访日期",
                            prop: "visit_time",
                            "label-width": 100
                          }
                        },
                        [
                          _c("DatePicker", {
                            staticStyle: { display: "block" },
                            attrs: {
                              type: "date",
                              placeholder: "请选择",
                              options: _vm.visit_time_option,
                              transfer: true
                            },
                            model: {
                              value: _vm.formItem.visit_time,
                              callback: function($$v) {
                                _vm.$set(_vm.formItem, "visit_time", $$v)
                              },
                              expression: "formItem.visit_time"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "客户预算", prop: "budget" } },
                        [
                          _c("Input", {
                            attrs: {
                              maxlength: 20,
                              placeholder: "客户预算（元）"
                            },
                            model: {
                              value: _vm.formItem.budget,
                              callback: function($$v) {
                                _vm.$set(_vm.formItem, "budget", $$v)
                              },
                              expression: "formItem.budget"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "分娩医院", prop: "hospital" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: {
                                filterable: "",
                                remote: "",
                                transfer: "",
                                clearable: "",
                                "remote-method": _vm.remoteMethod1,
                                loading: _vm.remoteLoading
                              },
                              on: { "on-query-change": _vm.remoteMethod },
                              model: {
                                value: _vm.formItem.hospital,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem, "hospital", $$v)
                                },
                                expression: "formItem.hospital"
                              }
                            },
                            _vm._l(_vm.hospitalList, function(option, index) {
                              return _c(
                                "Option",
                                {
                                  key: index,
                                  attrs: {
                                    value: option.label,
                                    label: option.label
                                  }
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(option.label))]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        color: "#ccc"
                                      }
                                    },
                                    [_vm._v(_vm._s(option.value))]
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "回访记录", prop: "content" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 2, maxRows: 5 },
                              maxlength: 500,
                              placeholder: "请在15-500字内描述回访内容"
                            },
                            model: {
                              value: _vm.formItem.content,
                              callback: function($$v) {
                                _vm.$set(_vm.formItem, "content", $$v)
                              },
                              expression: "formItem.content"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("h3", [_vm._v("回访信息")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba6382c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba6382c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commonTmp/CRM/CRM_returnInfo.vue
// module id = null
// module chunks = 